var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 439 439",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 194,
    height: 194,
    fill: "#f8682c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 17,
    width: 194,
    height: 194,
    fill: "#91c300"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 228,
    width: 194,
    height: 194,
    fill: "#00b4f1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 228,
    width: 194,
    height: 194,
    fill: "#ffc300"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft.a93a3c30201658d22716a9f2edcde068.svg";